var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plane-right",
    clipPath: "url(#clip0_7086_3517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 11.3161L8.33398 18.3337H6.66732L8.77232 11.3161H4.30565L2.91732 13.9477H1.66732L2.50065 10.0003L1.66732 6.05296L2.91732 6.05296L4.30648 8.68454H8.77315L6.66732 1.66699H8.33398L12.5448 8.68454H17.084C17.4155 8.68454 17.7334 8.82316 17.9679 9.06992C18.2023 9.31668 18.334 9.65136 18.334 10.0003C18.334 10.3493 18.2023 10.684 17.9679 10.9307C17.7334 11.1775 17.4155 11.3161 17.084 11.3161H12.5448Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 11.3161L8.33398 18.3337H6.66732L8.77232 11.3161H4.30565L2.91732 13.9477H1.66732L2.50065 10.0003L1.66732 6.05296L2.91732 6.05296L4.30648 8.68454H8.77315L6.66732 1.66699H8.33398L12.5448 8.68454H17.084C17.4155 8.68454 17.7334 8.82316 17.9679 9.06992C18.2023 9.31668 18.334 9.65136 18.334 10.0003C18.334 10.3493 18.2023 10.684 17.9679 10.9307C17.7334 11.1775 17.4155 11.3161 17.084 11.3161H12.5448Z",
    fill: "black",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7086_3517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneRight);
export default __webpack_public_path__ + "static/media/plane-right.68ae065ae2865fd7f4152aa6613c92de.svg";
export { ForwardRef as ReactComponent };